// 国际化英文表达部分
export default {
  common: {
    traceabilityDetails: "Traceability",
    certified: "Certified",
    cancel: "Cancel",
    confirm: "OK",
    loading: "Loading...",
    yes: "Yes",
    no: "No",
    language: "Language",
  },
  menu: {
    parkInfo: "Park",
    cropInfo: "Crop",
    videoInfo: "Video",
    environmentInfo: "Environment",
    farmInfo: "Farming",
    reportInfo: "Report",
    harvestInfo: "Harvest",
  },
  map: {
    baiDu: "Baidu",
    gaoDe: "AMap (Recommended)",
    tencent: "Tencent",
  },
  page: {
    parkInfo: {
      parkName: "Park Name",
      parkArea: "Area",
      parkAreaUnit: "acres",
      parkUser: "Manager",
      parkPhone: "Phone",
      parkAddress: "Address",
      parkRemark: "Introduction",
      parkImage: "Park Image",
    },
    cropInfo: {
      cropImage: "Crop Image",
      cropVariety: "Variety",
      cropName: "Crop Name",
      buyLink: "Buy Link",
      buyLinkDesc: "Link Description",
      position: "Location",
    },
    videoInfo: {
      videoImage: "Video Snapshot",
      videoName: "Video Name",
      cameraName: "Camera",
      videoStartTime: "Start Time",
      cropName: "Crop",
      shootNum: "Shots/Day",
      videoType: "Format",
      videoRemark: "Remarks",
      isOverVideo: "Video Generated",
    },
    environmentInfo: {
      environmentMetrics: "Environment Metrics",
      reportDate: "Date",
      minValue: "Min",
      maxValue: "Max",
      averageValue: "Avg",
      highestWarningValue: "Max Alert",
      lowestWarningValue: "Min Alert",
      trendChart: "Trend",
    },
    farmingInfo: {
      farmTitle: "Farming Task",
      farmUser: "Worker",
      farmMaterial: "Materials",
      targetCrop: "Crop",
      farmTime: "Date",
      farmMachine: "Machinery",
      farmImage: "Photos",
      farmContent: "Details",
    },
    reportInfo: {
      reportName: "Report Name",
      uploadTime: "Upload Date",
      reportRemark: "Remarks",
      reportImage: "Report Images",
    },
    pickInfo: {
      pickImage: "Harvest Photo",
      pickUser: "Picker",
      pickCrop: "Crop",
      pickNumber: "Weight (kg)",
      pickDate: "Harvest Date",
      generateTraceability: "Generate Trace",
      pickRemark: "Remarks",
    },
  },
  tips: {
    changeLocales: "Language: {lang}",
    jumpTipsTitle: "External Link",
    jumpTipsContent: "Leave to purchase page?",
    linkInvalid: "Purchase link is invalid, please contact the administrator",
    addressInvalid: "Navigation location is invalid, please contact the administrator",
  },
  empty: {
    commonEmpty: "No Data",
    noParkImage: "No park image",
    noOverVideo: "No video generated",
    noEnvironmentMetrics: "No environment metrics",
    noFarmImage: "No farming photos",
    noReportImage: "No report images",
    errorTime: "QR code expired",
    errorNum: "QR code usage limit reached"
  },
};